import React, { useState, useEffect } from 'react';
import { Plus, X, ChevronLeft, Edit, Trash, CheckCircle } from 'lucide-react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Addblogs from './blogadd';
import Blogtable from './blogtable';
import { deleteblog } from '../../../FeatureRedux/blogs/DeleteBlogreducer';
import { useDispatch } from 'react-redux';
import { getblog } from '../../../FeatureRedux/blogs/GetBlogReducer';
import { updateblog } from '../../../FeatureRedux/blogs/UpdateBlogReducer';

AOS.init();

const Blogfront = () => {
  const [showForm, setShowForm] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [blogs, setBlogs] = useState(JSON.parse(localStorage.getItem('blogs')) || []);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getblog());
  }, [dispatch]);

  const handleAddBlog = () => {
    setShowForm(true);
    setEditIndex(null);
  };

  const handleEdit = (index) => {
    setShowForm(true);
    setEditIndex(index);
  };

  const handleSubmit = (blog, isEdit) => {
    const existingBlogs = JSON.parse(localStorage.getItem('blogs')) || [];
    if (isEdit) {
      dispatch(updateblog(blog))
      return;
    } else {
      existingBlogs.push(blog);
      setShowSuccessModal(true);
    }
    localStorage.setItem('blogs', JSON.stringify(existingBlogs));
    setBlogs(existingBlogs);
    setShowForm(false);
  };

  const closeSuccessModal = () => setShowSuccessModal(false);
  const closeUpdateModal = () => setShowUpdateModal(false);
  const closeDeleteModal = () => setShowDeleteModal(false);

  return (
    <div className=" bg-gray-900 p-6" style={{
      overflowY: 'scroll',
      height: '80vh',
      width: '100%',
      scrollbarWidth: 'px',
      msOverflowStyle: 'none'
    }}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
          <div className="flex items-center mb-4 md:mb-0">
            {/* <button
              onClick={() => window.history.back()}
              className="mr-4 p-2 rounded-full hover:bg-gray-800 transition-colors"
            >
              <ChevronLeft className="w-6 h-6 text-gray-300" />
            </button> */}
            <h1 className="text-3xl font-bold text-white">Blog Management</h1>
          </div>
          <button
            onClick={handleAddBlog}
            className="flex items-center bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 py-3 rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all shadow-lg hover:shadow-xl"
          >
            <Plus className="w-5 h-5 mr-2" />
            Add New Blog
          </button>
        </div>

        {/* Blog Table */}
        <div className="bg-gray-800 rounded-xl shadow-xl overflow-hidden">
          <Blogtable
            blogs={blogs}
            handleEdit={handleEdit}
            showSuccessModal={showSuccessModal}
            showUpdateModal={showUpdateModal}
            showDeleteModal={showDeleteModal}
            closeSuccessModal={closeSuccessModal}
            closeUpdateModal={closeUpdateModal}
            closeDeleteModal={closeDeleteModal}
          />
        </div>

        {/* Add/Edit Blog Form Modal */}
        {showForm && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50 p-4">
            <div
              data-aos="fade-up"
              className="bg-gray-800 w-full max-w-3xl rounded-xl shadow-2xl overflow-hidden border border-gray-700"
            >
              <div className="flex justify-between items-center bg-gray-700 px-6 py-4 border-b border-gray-600">
                <h2 className="text-xl font-semibold text-white">
                  {editIndex !== null ? 'Edit Blog' : 'Add New Blog'}
                </h2>
                <button
                  onClick={() => setShowForm(false)}
                  className="text-gray-300 hover:text-white p-1 rounded-full hover:bg-gray-600 transition-colors"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
              <Addblogs
                onSubmit={handleSubmit}
                onCancel={() => setShowForm(false)}
                editIndex={editIndex}
                blogs={blogs}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Blogfront;

// import React, { useState, useEffect } from 'react';
// import { Plus, X, ChevronLeft } from 'lucide-react';
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import Addblogs from './blogadd';
// import Blogtable from './blogtable';
// import { deleteblog } from '../../../FeatureRedux/blogs/DeleteBlogreducer';
// import { useDispatch } from 'react-redux';
// import { getblog } from '../../../FeatureRedux/blogs/GetBlogReducer';
// import { updateblog } from '../../../FeatureRedux/blogs/UpdateBlogReducer';

// AOS.init();

// const Blogfront = () => {
//   const [showForm, setShowForm] = useState(false);
//   const [editIndex, setEditIndex] = useState(null);
//   const [blogs, setBlogs] = useState(JSON.parse(localStorage.getItem('blogs')) || []);
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const [showUpdateModal, setShowUpdateModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     // Fetch blogs when component mounts ||
//     // 
//     dispatch(getblog());
//   }, [dispatch]);

//   const handleAddBlog = () => {
//     setShowForm(true);
//     setEditIndex(null);
//   };

//   const handleEdit = (index) => {
//     setShowForm(true);
//     setEditIndex(index);
//   };
 

//   const handleSubmit = (blog, isEdit) => {
//     const existingBlogs = JSON.parse(localStorage.getItem('blogs')) || [];
//     if (isEdit) {
//       console.log(`object :: ${JSON.stringify(blog)}`);
//       // existingBlogs[editIndex] = blog;
//       // setShowUpdateModal(true);
//       dispatch(updateblog(blog))
//       return;
//     } else {
//       existingBlogs.push(blog);
//       setShowSuccessModal(true);
//     }
//     localStorage.setItem('blogs', JSON.stringify(existingBlogs));
//     setBlogs(existingBlogs);
//     setShowForm(false);
//   };

//   const closeSuccessModal = () => setShowSuccessModal(false);
//   const closeUpdateModal = () => setShowUpdateModal(false);
//   const closeDeleteModal = () => setShowDeleteModal(false);

//   return (
//     <div className="flex flex-col h-auto bg-gray-900 p-6" 
//     style={{
//       overflowY: 'scroll',
//       height: '80vh',
//       width: '100%',
//       scrollbarWidth: '1px',
//       msOverflowStyle: 'none'
//     }}
//       >
//       {/* Header with Add Blog Button */}
//       <h1 className="text-2xl font-bold text-white text-center">Blog List</h1>
//       <div className="flex justify-between items-center mb-6">
//         <button
//           onClick={() => window.history.back()}
//           className="flex items-center text-gray-800 hover:text-gray-600"
//         >
//           {/* <ChevronLeft className="w-5 h-5 text-white" /> */}
//         </button>
//         <button
//           onClick={handleAddBlog}
//           className="flex items-center text-center bg-blue-600 text-white px-4 py-2 z-99 rounded-md hover:bg-blue-700 transition-all"
//         >
//           <Plus className="w-5 h-5 mr-2" />
//           Add Blog
//         </button>
//       </div>

//       {/* Blog Table */}
//       <div className="flex-1 bg-gray-900 shadow-md rounded-md" >
//         <Blogtable
//           blogs={blogs}
//           handleEdit={handleEdit}
//           showSuccessModal={showSuccessModal}
//           showUpdateModal={showUpdateModal}
//           showDeleteModal={showDeleteModal}
//           closeSuccessModal={closeSuccessModal}
//           closeUpdateModal={closeUpdateModal}
//           closeDeleteModal={closeDeleteModal}
//         />
//       </div>

//       {/* Add/Edit Blog Form */}
//       {showForm && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//           <div
//             data-aos="fade-up"
//             className="bg-white w-11/12 max-w-2xl p-6 rounded-lg shadow-lg relative"
//           >
//             <button
//               onClick={() => setShowForm(false)}
//               className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
//             >
//               <X className="w-6 h-6" />
//             </button>
//             <Addblogs
//               onSubmit={handleSubmit}
//               onCancel={() => setShowForm(false)}
//               editIndex={editIndex}
//               blogs={blogs}
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Blogfront;
// import React, { useState } from 'react';
// import { Plus,X ,ChevronLeft} from 'lucide-react';
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import Addblogs from './blogadd';
// import Blogtable from './blogtable';
// import { deleteblog } from '../../../FeatureRedux/blogs/DeleteBlogreducer';
// import { useDispatch } from 'react-redux';

// AOS.init();

// const Blogfront = () => {
//   const [showForm, setShowForm] = useState(false);
//   const [editIndex, setEditIndex] = useState(null);
//   const [blogs, setBlogs] = useState(JSON.parse(localStorage.getItem('blogs')) || []);
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const [showUpdateModal, setShowUpdateModal] = useState(false);
//   const dispatch = useDispatch();


//   const handleAddBlog = () => {
//     setShowForm(true);
//     setEditIndex(null);
//   };

//   const handleEdit = (index) => {
//     setShowForm(true);
//     setEditIndex(index);
//   };

//   const handleDelete = async (id) => {
//     await dispatch(deleteblog(id));
//     // const updatedBlogs = blogs.filter((_, i) => i !== index);
//     // localStorage.setItem('blogs', JSON.stringify(updatedBlogs));
//     // setBlogs(updatedBlogs);
//   };

//   const handleSubmit = (blog, isEdit) => {
//     const existingBlogs = JSON.parse(localStorage.getItem('blogs')) || [];
//     if (isEdit) {
//       existingBlogs[editIndex] = blog;
//       setShowUpdateModal(true);
//     } else {
//       existingBlogs.push(blog);
//       setShowSuccessModal(true);
//     }
//     localStorage.setItem('blogs', JSON.stringify(existingBlogs));
//     setBlogs(existingBlogs);
//     setShowForm(false);
//   };

//   const closeSuccessModal = () => setShowSuccessModal(false);
//   const closeUpdateModal = () => setShowUpdateModal(false);

//   return (
//     <div className="flex flex-col h-auto bg-gray-900 p-6" 
    
    
//     style={{
//       overflow: 'auto',
//       height: '80vh',
//       width: '100%',
//       scrollbarWidth: '1px',
//       msOverflowStyle: 'none'
//     }}>
//       {/* Header with Add Blog Button */}
//         <h1 className="text-2xl font-bold text-white text-center">Blog List</h1>
//       <div className="flex justify-between items-center mb-6">
//       <button
//             onClick={() => window.history.back()}
//             className="flex items-center text-gray-800 hover:text-gray-600"
//           >
          
//           </button>
//         <button
//           onClick={handleAddBlog}
//           className="flex items-center text-center bg-blue-600 text-white px-4 py-2 z-99 rounded-md hover:bg-blue-700 transition-all"
//         >
//           <Plus className="w-5 h-5 mr-2" />
//           Add Blog
//         </button>
//       </div>

//       {/* Blog Table */}
//       <div className="flex-1  bg-gray-900 shadow-md rounded-md">
//         <Blogtable
//           blogs={blogs}
//           handleEdit={handleEdit}
//           handleDelete={handleDelete}
//           showSuccessModal={showSuccessModal}
//           showUpdateModal={showUpdateModal}
//           closeSuccessModal={closeSuccessModal}
//           closeUpdateModal={closeUpdateModal}
//         />
//       </div>

//       {/* Add/Edit Blog Form */}
//       {showForm && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//           <div
//             data-aos="fade-up"
//             className="bg-white w-11/12 max-w-2xl p-6 rounded-lg shadow-lg relative"
//           >
//             <button
//               onClick={() => setShowForm(false)}
//               className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
//             >
//               <X className="w-6 h-6" />
//             </button>
//             <Addblogs
//               onSubmit={handleSubmit}
//               onCancel={() => setShowForm(false)}
//               editIndex={editIndex}
//               blogs={blogs}
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Blogfront;

// import React, { useState } from 'react';
// import { Plus } from 'lucide-react';
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import Addblogs from './blogadd';
// import Blogtable from './blogtable';

// AOS.init();

// const Blogfront = () => {
//   const [showForm, setShowForm] = useState(false);
//   const [editIndex, setEditIndex] = useState(null);
//   const [blogs, setBlogs] = useState(JSON.parse(localStorage.getItem('blogs')) || []);
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const [showUpdateModal, setShowUpdateModal] = useState(false);

//   const handleAddBlog = () => {
//     setShowForm(true);
//     setEditIndex(null);
//   };

//   const handleEdit = (index) => {
//     setShowForm(true);
//     setEditIndex(index);
//   };

//   const handleDelete = (index) => {
//     const updatedBlogs = blogs.filter((_, i) => i !== index);
//     localStorage.setItem('blogs', JSON.stringify(updatedBlogs));
//     setBlogs(updatedBlogs);
//   };

//   const handleSubmit = (blog, isEdit) => {
//     const existingBlogs = JSON.parse(localStorage.getItem('blogs')) || [];
//     if (isEdit) {
//       existingBlogs[editIndex] = blog;
//       setShowUpdateModal(true);
//     } else {
//       existingBlogs.push(blog);
//       setShowSuccessModal(true);
//     }
//     localStorage.setItem('blogs', JSON.stringify(existingBlogs));
//     setBlogs(existingBlogs);
//     setShowForm(false);
//   };

//   const closeSuccessModal = () => setShowSuccessModal(false);
//   const closeUpdateModal = () => setShowUpdateModal(false);

//   return (
//     <div className="flex flex-col h-screen bg-gray-100 p-6">
//       {/* Header with Add Blog Button */}
//       <div className="flex justify-between items-center mb-6">
//         <h1 className="text-2xl font-bold text-gray-800">Blog List</h1>
//         <button
//           onClick={handleAddBlog}
//           className="flex items-center bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-all"
//         >
//           <Plus className="w-5 h-5 mr-2" />
//           Add Blog
//         </button>
//       </div>

//       {/* Blog Table */}
//       <div className="flex-1 overflow-auto bg-white shadow-md rounded-md">
//         <Blogtable
//           blogs={blogs}
//           handleEdit={handleEdit}
//           handleDelete={handleDelete}
//           showSuccessModal={showSuccessModal}
//           showUpdateModal={showUpdateModal}
//           closeSuccessModal={closeSuccessModal}
//           closeUpdateModal={closeUpdateModal}
//         />
//       </div>

//       {/* Add/Edit Blog Form */}
//       {showForm && (
//         <div
//           data-aos="fade-left"
//           className="fixed inset-y-0 left-0 w-96 bg-white shadow-lg p-6 overflow-y-auto"
//         >
//           <Addblogs
//             onSubmit={handleSubmit}
//             onCancel={() => setShowForm(false)}
//             editIndex={editIndex}
//             blogs={blogs}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default Blogfront;


